import { FC, PropsWithChildren } from 'react';
import { useLocation } from 'react-router-dom';
import SideBar from './SideBar';

const Layout: FC<PropsWithChildren> = ({ children }) => {
  const location = useLocation();
  const pathname = location.pathname;

  if (pathname === '/mobi-for-sure') {
    return <div className='flex h-screen w-full'>{children}</div>;
  }

  return (
    <div className='flex h-screen w-full'>
      <SideBar />
      {children}
    </div>
  );
};

export default Layout;
